import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BannerTile as CotopaxiBannerTile } from '@as/cotopaxi';
import { ABTestCookie } from '@as-react/common-types';
import { useState, useRef, useEffect } from 'react';
import { useABTest } from '../../../hooks/useABTest';
import { useElementIsVisible } from '../../../hooks/useElementIsVisible';
import { useZitcha } from '../../../hooks/useZitcha';
import { removeURLParameter } from '../../../util/UrlUtil';
import { EmbeddedContent } from '../../embedded-content/EmbeddedContent';
const FRAMELESS_PARAM_NAME = 'frameless';
export const BannerTile = ({ lazy, url, image, alt, zitchaInfo, andesLayout }) => {
    var _a;
    const [embeddedContentLink, setEmbeddedContentLink] = useState('');
    const { hasBCookie: showEmbeddedContent } = useABTest(ABTestCookie.EMBEDDED_CONTENT);
    const { collectClick, collectImpression } = useZitcha();
    const bannerRef = useRef(null);
    const isVisible = useElementIsVisible(bannerRef, { threshold: 0.01 });
    const collectData = {
        adFormat: 'native_banner',
        adId: (_a = zitchaInfo === null || zitchaInfo === void 0 ? void 0 : zitchaInfo.adId) !== null && _a !== void 0 ? _a : '',
        placementId: '',
    };
    const handleBannerClick = (e) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (zitchaInfo) {
            e.preventDefault();
            e.stopPropagation();
            yield collectClick(Object.assign(Object.assign({}, collectData), { placementId: `{"position":${(_a = zitchaInfo === null || zitchaInfo === void 0 ? void 0 : zitchaInfo.position) !== null && _a !== void 0 ? _a : 0}}` })).finally(() => {
                if (showEmbeddedContent && url.includes(FRAMELESS_PARAM_NAME)) {
                    setEmbeddedContentLink(removeURLParameter(url, FRAMELESS_PARAM_NAME));
                }
                window.location.href = removeURLParameter(url, FRAMELESS_PARAM_NAME);
            });
        }
        else {
            if (showEmbeddedContent && url.includes(FRAMELESS_PARAM_NAME)) {
                e.preventDefault();
                setEmbeddedContentLink(removeURLParameter(url, FRAMELESS_PARAM_NAME));
            }
        }
    });
    useEffect(() => {
        var _a;
        if (!isVisible) {
            return;
        }
        if (zitchaInfo) {
            collectImpression(Object.assign(Object.assign({}, collectData), { placementId: (_a = zitchaInfo === null || zitchaInfo === void 0 ? void 0 : zitchaInfo.impressionURL) !== null && _a !== void 0 ? _a : '' }));
        }
    }, [isVisible]);
    return (_jsxs("div", { ref: bannerRef, className: `a:h-full ${andesLayout ? 'a:pb-10' : ''}`, children: [_jsx(CotopaxiBannerTile, { lazy: lazy, url: removeURLParameter(url, FRAMELESS_PARAM_NAME), src: image, title: alt, alt: alt, onClick: handleBannerClick }), _jsx(EmbeddedContent, { isOpen: Boolean(embeddedContentLink), href: embeddedContentLink, onClose: () => setEmbeddedContentLink('') })] }));
};
